import { apiClient } from '@/src/lib/api/client/apiClient';

/**
 * Mirrors `com.hotpads.hotpadsapi.api.hp.webapi.experiment.dto.HpTreatmentDto`.
 * The backend returns `'off'` for users not enrolled in any variant — we treat
 * that as the control bucket via `isControlTreatment` below.
 */
export type HpTreatmentDto = {
  featureName: string;
  treatment: string;
};

export type GetTreatmentsByGuidBody = {
  experiments: ReadonlyArray<string>;
  userGuid: string;
};

type GetTreatmentsByGuidResponse = {
  data?: ReadonlyArray<HpTreatmentDto> | null;
  error?: string | null;
};

/**
 * Calls hotpads-api `POST /v2/experiment/getTreatmentsByGuid` — the same path
 * legacy hotpads-web uses. The backend reads `userGuid` from the body, calls
 * `RpSplitClient.getTreatment(guid, featureName, attrs)`, and returns one
 * `HpTreatmentDto` per requested feature.
 */
export async function fetchTreatmentsByGuid(
  body: GetTreatmentsByGuidBody,
  options?: { timeout?: number },
): Promise<ReadonlyArray<HpTreatmentDto>> {
  const response = await apiClient<GetTreatmentsByGuidResponse>({
    method: 'POST',
    path: '/v2/experiment/getTreatmentsByGuid',
    body: {
      experiments: body.experiments,
      userGuid: body.userGuid,
    },
    timeout: options?.timeout,
  });

  return response?.data ?? [];
}

export function isControlTreatment(treatment: string | undefined): boolean {
  return !treatment || treatment === 'control' || treatment === 'off';
}
